import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { PlayerTrackingHistoryCreatePayload } from '@modules/players/submodules/PlayerProfile/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  CREATE_PLAYER_HISTORY_MUTATION_KEY,
  CREATE_PLAYER_HISTORY_QUERY_URL,
  PLAYER_PROFILE_PERMISSIONS,
  PLAYER_TRACKING_HISTORY_QUERY_KEY,
} from '@modules/players/submodules/PlayerProfile/constants';
import { useToastStore } from '@modules/toast/store';

export default function useTrackingHistoryCreateMutation():
IContextMutationResult<void, Error, PlayerTrackingHistoryCreatePayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, PlayerTrackingHistoryCreatePayload>({
    mutationKey: [CREATE_PLAYER_HISTORY_MUTATION_KEY],
    mutationFn: ({ data, playerId, merchant }) => fetchPost<void>(
      CREATE_PLAYER_HISTORY_QUERY_URL,
      { ...data },
      {
        permission: PLAYER_PROFILE_PERMISSIONS.PLAYERS_TRACKING,
        urlParams: {
          playerId,
        },
        queryParams: {
          merchant,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [PLAYER_TRACKING_HISTORY_QUERY_KEY] });
      displayPresetToast('created');
    },
  });
}
